// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { useContext } from 'react';

export const PartiesContext = React.createContext<PartiesState>({
  operator: '',
  party: '',
  bridgeOperator: '',
  crossChainRepresentative: '',
});

type PartiesState = {
  operator: string;
  party: string;
  bridgeOperator: string;
  crossChainRepresentative: string;
};

export const useParties: () => PartiesState = () => {
  return useContext<PartiesState>(PartiesContext);
};
